// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"BrandLogo_logoWrapper__vp6fF","logoImg":"BrandLogo_logoImg__dHdfv"};